var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModality2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fdllpd6cya)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#epbn5vwhib)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.022.85c.914 0 1.631 0 2.207.05.587.051 1.072.156 1.51.394a3.961 3.961 0 0 1 1.676 1.78c.223.466.323.981.37 1.605.048.612.048 1.374.048 2.345v.048c0 .971 0 1.733-.047 2.345-.048.624-.148 1.139-.371 1.605a3.962 3.962 0 0 1-1.675 1.78c-.44.238-.924.343-1.51.394-.577.05-1.294.05-2.208.05H8.499v1.299c.417.03.83.1 1.239.209l1.05.279c.267.07.43.36.363.644a.499.499 0 0 1-.606.386l-1.05-.278a5.82 5.82 0 0 0-2.991 0l-1.05.278a.499.499 0 0 1-.606-.386c-.067-.285.096-.573.363-.644l1.05-.28a6.773 6.773 0 0 1 1.238-.208v-1.3H5.977c-.914 0-1.631 0-2.208-.05-.586-.05-1.071-.155-1.51-.393a3.962 3.962 0 0 1-1.675-1.78c-.224-.466-.323-.981-.37-1.605C.165 8.805.165 8.043.165 7.072v-.048c0-.971 0-1.733.047-2.345.048-.624.147-1.139.37-1.605a3.961 3.961 0 0 1 1.676-1.78c.439-.238.924-.343 1.51-.394C4.346.85 5.062.85 5.977.85h4.045z",
    fill: "#7ECEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.022.85c.914 0 1.631 0 2.207.05.587.051 1.072.156 1.51.394a3.961 3.961 0 0 1 1.676 1.78c.223.466.323.981.37 1.605.048.612.048 1.374.048 2.345v.048c0 .971 0 1.733-.047 2.345-.048.624-.148 1.139-.371 1.605a3.962 3.962 0 0 1-1.675 1.78c-.44.238-.924.343-1.51.394-.577.05-1.294.05-2.208.05H8.499v1.299c.417.03.83.1 1.239.209l1.05.279c.267.07.43.36.363.644a.499.499 0 0 1-.606.386l-1.05-.278a5.82 5.82 0 0 0-2.991 0l-1.05.278a.499.499 0 0 1-.606-.386c-.067-.285.096-.573.363-.644l1.05-.28a6.773 6.773 0 0 1 1.238-.208v-1.3H5.977c-.914 0-1.631 0-2.208-.05-.586-.05-1.071-.155-1.51-.393a3.962 3.962 0 0 1-1.675-1.78c-.224-.466-.323-.981-.37-1.605C.165 8.805.165 8.043.165 7.072v-.048c0-.971 0-1.733.047-2.345.048-.624.147-1.139.37-1.605a3.961 3.961 0 0 1 1.676-1.78c.439-.238.924-.343 1.51-.394C4.346.85 5.062.85 5.977.85h4.045z",
    stroke: "url(#25weodtfnc)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#jgsgju31yd)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.59c0 .293.224.53.5.53h4c.276 0 .5-.237.5-.53 0-.294-.224-.532-.5-.532H8c-.276 0-.5.238-.5.532zm-2.167 0c0 .39-.298.708-.666.708-.369 0-.667-.317-.667-.708 0-.392.298-.709.667-.709.368 0 .666.317.666.709z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "epbn5vwhib",
    x: -24.584,
    y: -23.9,
    width: 65.166,
    height: 64.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_400_1619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_400_1619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "jgsgju31yd",
    x: 1,
    y: 6.881,
    width: 24.5,
    height: 17.416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_400_1619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_400_1619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "25weodtfnc",
    x1: 0.166,
    y1: 0.85,
    x2: 15.397,
    y2: 16.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fdllpd6cya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v17H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModality2);
export default __webpack_public_path__ + "static/media/Modality2.d84541ae78c17e34c439c5709c89f3ec.svg";
export { ForwardRef as ReactComponent };